// extracted by mini-css-extract-plugin
export var useCase = "index-module--useCase--PPm0S";
export var useCase__title = "index-module--useCase__title--LmX9K";
export var useCase__text = "index-module--useCase__text--akNYL";
export var mobileCases = "index-module--mobileCases--WSNgv";
export var mobileCases__titles = "index-module--mobileCases__titles--KAphT";
export var cases = "index-module--cases--bFeLn";